import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import QuestionWithRetrieval from "../QuestionWithRetrieval";
import Question from "../../containers/Question";
import { getUserInfo, setApisURLs, setApiConfig, setEmbedApiConfig, setAppInitialized } from "../../submodule/src/utils/api";
import { getCurrentTenant, setCurrentTenant, setUserTenants } from "../../submodule/src/utils/roles";
import { getEmbedApiKey } from "../../submodule/src/utils/embed-auth-bridge";
import { useAuth } from "../../context/AuthContext";
import Lottie from "lottie-react";
import animationData from "../../assets/cogsol-loading.json";
import Header from "../../components/Header";

const isClientCredentialsMode =
  (process.env.REACT_APP_AUTH_MODE || "").toLowerCase() === "client_credentials";
const isHeaderVisible = (process.env.REACT_APP_HEADER_VISIBLE || "").toLowerCase() === "true";

const MainRouter = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { loading: authLoading, initialized, isAuthenticated, login } = useAuth();
  const isEmbed = new URLSearchParams(window.location.search).get("embed") === "true";

  useEffect(() => {
    if (authLoading || !initialized) return;

    const initializeApp = async () => {
      if (isAuthenticated()) {
        // Apply tenant from query params if provided (e.g. ?tenant=dev)
        // Remove it from URL after reading so subsequent reloads (e.g. tenant switch) don't override the selector.
        const params = new URLSearchParams(window.location.search);
        const tenantParam = params.get("tenant");
        if (tenantParam) {
          setCurrentTenant(tenantParam);
          params.delete("tenant");
          const cleaned = params.toString();
          const newUrl = `${window.location.pathname}${cleaned ? `?${cleaned}` : ""}`;
          window.history.replaceState({}, "", newUrl);
        }

        if (isClientCredentialsMode) {
          const tenant = process.env.REACT_APP_CLIENT_CREDENTIALS_TENANT;
          setCurrentTenant(tenant);
          setUserTenants([tenant]);
          sessionStorage.setItem("tenantRoleMap", JSON.stringify({ [tenant]: "user" }));
          setApisURLs(tenant);
          await setApiConfig(tenant);
        } else if (isEmbed) {
          // Embed mode: parent sent apiKey + tenant via postMessage.
          // Skip getUserInfo/extractTenantsAndApiKeys (token may lack api_keys claim).
          // WORKAROUND: see iframe-auth.ts getStoredApiKey for context.
          const apiKey = getEmbedApiKey();
          const tenant = getCurrentTenant();
          setEmbedApiConfig(apiKey, tenant);
        } else {
          // Standalone: extract api_keys from token claims via MSAL
          await getUserInfo();
          const tenant = getCurrentTenant();
          setApisURLs(tenant);
          await setApiConfig(tenant);
        }

        setAppInitialized(true);
        setIsLoading(false);
      } else {
        login();
      }
    };

    initializeApp();
  }, [authLoading, initialized, isAuthenticated, isEmbed, login]);

  if (isLoading || !isAuthenticated())
    return (
      <div className="flex justify-center items-center h-screen">
        <div>
          <Lottie
            animationData={animationData}
            style={{
              height: "260px",
              width: "260px",
              margin: "auto",
              marginTop: "0px",
            }}
          />
        </div>
      </div>
    );

  return (
    <BrowserRouter>
      {!isEmbed && isHeaderVisible && <Header />}
      <Routes>
        <Route index element={<QuestionWithRetrieval />} />
        <Route
          path="projects/:idRetrieval"
          element={<QuestionWithRetrieval />}
        />
        <Route path="projects/:idRetrieval/chats/:id" element={<Question />} />
      </Routes>
    </BrowserRouter>
  );
};

export default MainRouter;
